import { MatchPeriod } from "@motain/xpa-proto-files-web/lib/types/match_card";

export const LIVE_MATCH_PERIODS = [
  MatchPeriod.FIRST_HALF,
  MatchPeriod.SECOND_HALF,
  MatchPeriod.EXTRA_FIRST_HALF,
  MatchPeriod.EXTRA_SECOND_HALF,
  MatchPeriod.HALF_TIME,
  MatchPeriod.PENALTIES,
  MatchPeriod.INTERRUPT,
];

export const POST_MATCH_PERIODS = [
  MatchPeriod.FULL_TIME,
  MatchPeriod.FULL_TIME_PENALTIES,
];
